import { Component, inject, input } from '@angular/core';
import { componentViewModelSelector } from '@core/experience-editor-utils';
import { SolarPanelsResultOverviewSummaryRendering } from '@feh/solar-panels-models';
import {
  selectSolarPanelsResultOverviewViewModel,
  SolarPanelsProductTrackingConfig,
} from '@feh/solar-panels-store';
import { Store } from '@ngrx/store';
import { SolarPanelsResultOverviewSummaryUiComponent } from '@feh/solar-panels-ui';

import { mockSolarPanelsResultOverviewViewModel } from '../solar-panels-result-overview-container/solar-panels-result-overview-container.component.xp.mock';

@Component({
  selector: 'wl-solar-panels-result-overview-summary-container',
  standalone: true,
  templateUrl:
    './solar-panels-result-overview-summary-container.component.html',
  imports: [SolarPanelsResultOverviewSummaryUiComponent],
})
export class SolarPanelsResultOverviewSummaryContainerComponent {
  readonly rendering =
    input.required<SolarPanelsResultOverviewSummaryRendering>();

  readonly store$ = inject(Store);
  readonly trackingConfig = inject(SolarPanelsProductTrackingConfig);

  readonly viewModel = this.store$.selectSignal(
    componentViewModelSelector(
      selectSolarPanelsResultOverviewViewModel,
      mockSolarPanelsResultOverviewViewModel
    )
  );
}
